import { defineStore } from 'pinia'
import type { BfApi } from '@library/services'

export const useBfInjectStore = defineStore('bf-inject', () => {
  let _bfApi: BfApi['bf'] | null = null

  function setBfApi(value: BfApi['bf']) {
    _bfApi = value
  }

  function getBfApi(): BfApi['bf'] {
    if (!_bfApi) {
      throw Error('請呼叫 useBfApiStore.setBfApi 方法設定 Library API')
    }

    return _bfApi
  }

  return {
    getBfApi,
    setBfApi
  }
})
